/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/membership/action/membershipActionTypes';

// // $FlowIssue
// export default combineReducers({
//   sync: syncAvailabilityReducer,
//   manual: manualAvailabilityReducer
// });

const initialState = {
  isFetching: false,
  result: null,
};

const _setIsFetching = (state: Object) => ({
  ...state,
  isFetching: true,
});

const _setResult = (state: Object, action: Object) => {
  const { result } = action;
  return {
    ...state,
    isFetching: false,
    result,
  };
};

const _setFailure = (state: Object) => ({
  ...state,
  isFetching: false,
  result: null,
});

export default createReducer(initialState, {
  [types.FETCH_CALENDAR_SYNC_STATUS_REQUEST]: _setIsFetching,
  [types.FETCH_CALENDAR_SYNC_STATUS_SUCCESS]: _setResult,
  [types.FETCH_CALENDAR_SYNC_STATUS_FAILURE]: _setFailure,
});
